import { Navigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useAuthenticationContext } from '../Contexts/App/AuthenticationContext';
import Login from '../Pages/Login/Login';

const LoginRouteRoot = (): React.ReactElement => {
    const userContext = useAuthenticationContext();
    const [searchParams, _] = useSearchParams();

    // Dont allow navigation to login if user is already logged in
    if (userContext.isLoggedIn()) {
        return <Navigate to="/dashboard" replace />;
    }

    const redirectToAfterLogin = searchParams.get('redirectTo') ?? undefined;

    return <Login redirectToAfterLogin={redirectToAfterLogin} />;
};

export default LoginRouteRoot;
